import { selector, selectorFamily } from 'recoil';

import { productItemState, productStatusState } from '../atom';
import {
  DynamicAssetsQueryCustomerParams,
  DynamicCustomFiltersProps,
  DynamicMarketStatusProps,
  ProductItem,
  ProductStatus,
} from '../types';

export const changeProductStatus = selector({
  key: 'changeProductStatus',
  set: ({ set }, newStatus) => {
    const data = newStatus as ProductStatus;
    set(productStatusState, data);
  },
  get: ({ get }) => {
    const currentStatus = get(productStatusState);
    return currentStatus.status;
  },
});

export const productItem = selector({
  key: 'productItem',
  set: ({ set, get }, newValue) => {
    const product = get(productItemState);
    const data = { current: newValue, previous: product.current } as ProductItem;
    set(productItemState, data);
  },
  get: ({ get }) => {
    const item = get(productItemState);
    return item;
  },
});

export const hasProductItem = selector({
  key: 'hasProductItem',
  get: ({ get }) => {
    const product = get(productItemState);
    return Object.keys(product.current)?.length > 0;
  },
});

export const emptyMarketStatusQuery = selector<DynamicMarketStatusProps>({
  key: 'NewApplication/emptyMarketStatusQuery',
  get: async () => ({ isOpen: true, message: '' }),
});

export const emptyCustomFiltersQuery = selectorFamily<
  DynamicCustomFiltersProps,
  DynamicAssetsQueryCustomerParams
>({
  key: 'NewApplication/emptyCustomFiltersQuery',
  get: () => {
    return async () => ({ filters: [] });
  },
});

export * from './fixedIncome';
export * from './funds';
export * from './equity';
export * from './directTreasury';
export * from './structuredOperations';
export * from './publicOffer';
export * from './clubs';
export * from './privatePension';
